export { default } from 'shared/components/progressLinear'
